import { browserLocalPersistence, getAuth, setPersistence } from "firebase/auth";
import firebase from "firebase/compat/app";
import "firebase/remote-config";

function checkIOS() {
  if (typeof navigator === 'undefined') return false; // Server-side safety check

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Check for iOS by looking for iPhone, iPad, or iPod in the user agent
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}

export const serverConfig = {
  cookieName: process.env.AUTH_COOKIE_NAME!,
  cookieSignatureKeys: [
    process.env.AUTH_COOKIE_SIGNATURE_KEY_CURRENT!,
    process.env.AUTH_COOKIE_SIGNATURE_KEY_PREVIOUS!,
  ],
  cookieSerializeOptions: {
    path: "/",
    httpOnly: true,
    secure: process.env.USE_SECURE_COOKIES!,
    sameSite: checkIOS() ? "None" : "Lax" as const,
    maxAge: 12 * 60 * 60 * 24,
  },
  serviceAccount: {
    projectId: process.env.NEXT_PUBLIC_PROJECT_ID!,
    clientEmail: process.env.FIREBASE_ADMIN_CLIENT_EMAIL!,
    privateKey: process.env.FIREBASE_ADMIN_PRIVATE_KEY?.replace(/\\n/g, "\n")!,
  },
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY!,
};

export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY!,
  authDomain: process.env.NEXT_PUBLIC_AUTH_DOMAIN!,
  databaseURL: process.env.NEXT_PUBLIC_DATABASE_URL!,
  projectId: process.env.NEXT_PUBLIC_PROJECT_ID!,
  storageBucket: process.env.NEXT_PUBLIC_STORAGE_BUCKET!,
  messagingSenderId: process.env.NEXT_PUBLIC_MESSAGING_SENDER_ID!,
  appId: process.env.NEXT_PUBLIC_APP_ID!,
  measurementId: process.env.NEXT_PUBLIC_MEASUREMENT_ID!,
};
const firebaseApp = firebase.initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);

setPersistence(auth, browserLocalPersistence).catch(err => console.log(JSON.stringify(err)))

export default firebaseApp;
